import React from 'react';

import {SECTION_MEDIA_SETTINGS_DESCRIPTION} from '../constants';
import {MediaSectionSettingsContextProvider} from './contexts/MediaSectionSettingsContextProvider';
import {MediaSettingsDrawerContent} from './MediaSettingsDrawerContent';
import {SettingsLevel} from './types';

export const SectionMediaSettingsDrawer = ({
  header,
}: {
  header: React.ReactNode;
}) => {
  return (
    <MediaSectionSettingsContextProvider>
      <MediaSettingsDrawerContent
        header={header}
        description={SECTION_MEDIA_SETTINGS_DESCRIPTION}
        settingsLevel={SettingsLevel.SECTION}
      />
    </MediaSectionSettingsContextProvider>
  );
};
